// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.yj-sso[data-v-510c2172] {\n  padding: 30px;\n  text-align: center;\n  color: #999;\n}\n.yj-sso-logout[data-v-510c2172],\n.yj-sso-back[data-v-510c2172] {\n  color: #2877ff;\n  margin-top: 8px;\n  cursor: pointer;\n}\n.yj-sso-back[data-v-510c2172] {\n  display: none;\n}\n.yj-sso-logout[data-v-510c2172]:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
